import { ETrackingReducerActions, ITrackingReducerAction } from './types';
import { TTrackingPageData, TUserTrackingData } from '../../types';

export function setTrackingData(user: TUserTrackingData, page: TTrackingPageData): ITrackingReducerAction {
  return {
    type: ETrackingReducerActions.SetTrackingState,
    payload: {
      user,
      page,
    },
  };
}
